const deriveSpotPlpView = (params) => {
    const preservedView = params.get('view')
    params.delete('view')

    const hasFilterParams = [...params.keys()].some((key) => key.startsWith('filter.'))
    if (!hasFilterParams) {
        return params
    }

    const productTypes = params.getAll('filter.p.product_type')
    const familias = params.getAll('filter.p.m.custom.familia_olfativa')
    const aromas = params.getAll('filter.p.m.custom.aroma')
    const familiasProducto = params.getAll('filter.p.m.custom.familia_producto')
    const has350 = productTypes.includes('Home Spray 350ml')
    const has500 = productTypes.includes('Home Spray 500ml')

    const difusorFormatViews = [
        'difusor-de-varilla',
        'difusor-de-varillas-175ml',
        'difusor-de-varillas-250ml',
    ]

    if (preservedView && aromas.length === 1 && productTypes.length === 0 && familias.length === 0) {
        params.set('view', preservedView)
        return params
    }

    if (has350 && has500) {
        params.set('view', 'home-sprays')
        return params
    }
    if (has350 && productTypes.length === 1) {
        params.set('view', 'home-spray-500ml-copia')
        return params
    }
    if (has500 && productTypes.length === 1) {
        params.set('view', 'spray-home-lh-500-ml')
        return params
    }

    const hasRefillDifusor = productTypes.includes('Refill Difusor Varillas')
    const hasRefillSpray = productTypes.includes('Refill Home Spray')
    if (hasRefillDifusor && hasRefillSpray) {
        params.set('view', 'refill')
        return params
    }

    const productTypeViews = {
        'Difusor de Varillas 150ml': 'difusor-de-varillas-150ml',
        'Difusor de Varillas 175ml': 'difusor-de-varillas-175ml',
        'Difusor de Varillas 250ml': 'difusor-de-varillas-250ml',
        'Refill Difusor Varillas': 'refill-difusor-de-varillas',
        'Refill Home Spray': 'refill-home-spray',
        'Home Diffuser': 'home-diffuser',
        'Esencia Concentrada': 'esencias-concentradas',
        'Aromatizador Auto': 'aromatizadores-para-auto',
        'Vela de Soya 235gr': 'vela-de-soya-235gr',
        'Vela de Soya 415g': 'vela-de-soya-415g',
    }

    const difusorTypes = ['Difusor de Varillas 150ml', 'Difusor de Varillas 175ml', 'Difusor de Varillas 250ml']
    const allDifusores = productTypes.length === 3 && productTypes.every((t) => difusorTypes.includes(t))
    if (allDifusores) {
        if (preservedView && difusorFormatViews.includes(preservedView)) {
            params.set('view', preservedView)
            return params
        }
        params.set('view', 'difusores-de-varillas')
        return params
    }

    if (productTypes.length === 1 && productTypeViews[productTypes[0]]) {
        params.set('view', productTypeViews[productTypes[0]])
        return params
    }

    const familiaViews = {
        Frutales: 'todo-aromas-frutales',
        'Cítricos': 'todo-aromas-citricos',
        Dulces: 'aromas-dulces',
        Maderosos: 'aromas-maderosos',
        Florales: 'florales-1',
    }

    if (familias.length === 1 && productTypes.length === 0 && familiaViews[familias[0]]) {
        params.set('view', familiaViews[familias[0]])
    }

    const familiaProductoViews = {
        'Difusores de Varillas': 'difusores-de-varillas',
        'Home Spray': 'home-sprays',
        'Refill': 'refill',
        'Home Diffuser': 'home-diffuser-1',
        'Aromatizador Auto': 'aromatizadores-para-auto',
        'Spray Alcohol': 'alcohol-spray-100ml',
        'Pet Spray': 'alcohol-spray-100ml-copia',
        'Velas de Soya': 'todo-velas-de-soya',
    }

    if (familiasProducto.length === 1 && productTypes.length === 0 && familias.length === 0 && familiaProductoViews[familiasProducto[0]]) {
        params.set('view', familiaProductoViews[familiasProducto[0]])
    }

    return params
}

const syncSpotPlpViewParam = (params) => deriveSpotPlpView(params)

const sanitizeCollectionFilterParams = (params, form) => {
    const slider = form?.querySelector('.filter-price-group-slider')
    const rangeMin = Number(slider?.dataset.rangeMin ?? 0)
    const rangeMax = Number(slider?.dataset.rangeMax ?? 0)
    const minValue = Number(params.get('filter.v.price.gte'))
    const maxValue = Number(params.get('filter.v.price.lte'))

    if (!params.has('filter.v.price.gte') || Number.isNaN(minValue) || minValue <= rangeMin) {
        params.delete('filter.v.price.gte')
    }

    if (!params.has('filter.v.price.lte') || Number.isNaN(maxValue) || maxValue >= rangeMax) {
        params.delete('filter.v.price.lte')
    }

    if (!params.get('sort_by')) {
        params.delete('sort_by')
    }

    return params
}

const buildCollectionFiltersUrl = (form) => {
    const params = sanitizeCollectionFilterParams(
        syncSpotPlpViewParam(new URLSearchParams(new FormData(form))),
        form
    )
    const basePath = form.getAttribute('action') || window.location.pathname
    const query = params.toString()
    return query ? `${basePath}?${query}` : basePath
}

const replaceNodeIfPresent = (currentNode, nextNode) => {
    if (!currentNode) return
    if (nextNode) {
        currentNode.replaceWith(nextNode)
        return
    }
    currentNode.remove()
}

const spotPlpPrefetchCache = new Map()
let spotPlpNavToken = 0

const SPOT_PLP_HANDLE_QUERY = {
    'difusores-de-varillas': 'filter.p.m.custom.familia_producto=Difusores de Varillas',
    'difusor-de-varilla': 'filter.p.product_type=Difusor de Varillas 150ml',
    'difusor-de-varillas-150ml': 'filter.p.product_type=Difusor de Varillas 150ml',
    'difusor-de-varillas-175ml': 'filter.p.product_type=Difusor de Varillas 175ml',
    'difusor-de-varillas-250ml': 'filter.p.product_type=Difusor de Varillas 250ml',
    'refill-difusor-de-varillas': 'filter.p.product_type=Refill Difusor Varillas',
    'home-sprays': 'filter.p.m.custom.familia_producto=Home Spray',
    'home-spray-500ml-copia': 'filter.p.product_type=Home Spray 350ml',
    'spray-home-lh-500-ml': 'filter.p.product_type=Home Spray 500ml',
    'refill-home-spray': 'filter.p.product_type=Refill Home Spray',
    'refill': 'filter.p.m.custom.familia_producto=Refill',
    'home-diffuser': 'filter.p.product_type=Home Diffuser',
    'home-diffusers': 'filter.p.product_type=Home Diffuser',
    'home-diffuser-1': 'filter.p.m.custom.familia_producto=Home Diffuser',
    'esencia-concentrada': 'filter.p.product_type=Esencia Concentrada',
    'esencias-concentradas': 'filter.p.product_type=Esencia Concentrada',
    'aromatizadores-para-auto': 'filter.p.m.custom.familia_producto=Aromatizador Auto',
    'aromatizador-de-auto-copia': 'filter.p.m.custom.familia_producto=Aromatizador Auto',
    'alcohol-spray-100ml': 'filter.p.m.custom.familia_producto=Spray Alcohol',
    'alcohol-spray-100ml-copia': 'filter.p.m.custom.familia_producto=Pet Spray',
    'todo-aromas-frutales': 'filter.p.m.custom.familia_olfativa=Frutales',
    'aromas-frutales': 'filter.p.m.custom.familia_olfativa=Frutales',
    'todo-aromas-citricos': 'filter.p.m.custom.familia_olfativa=Cítricos',
    'aroma-citrico': 'filter.p.m.custom.familia_olfativa=Cítricos',
    'aromas-citricos': 'filter.p.m.custom.familia_olfativa=Cítricos',
    'aromas-dulces': 'filter.p.m.custom.familia_olfativa=Dulces',
    'aromas-maderosos': 'filter.p.m.custom.familia_olfativa=Amaderados',
    'aromas-maderosos-1': 'filter.p.m.custom.familia_olfativa=Amaderados',
    'florales-1': 'filter.p.m.custom.familia_olfativa=Florales',
    'velas-2025': 'filter.p.product_type=Vela de Soya 235gr',
    'vela-de-soya-235gr': 'filter.p.product_type=Vela de Soya 235gr',
    'vela-de-soya-415g': 'filter.p.product_type=Vela de Soya 415g',
    'todo-velas-de-soya': 'filter.p.m.custom.familia_producto=Velas de Soya',
}

// Menu handle -> real collection page (SEO: indexable, self-canonical category pages).
// Audited for product-membership parity vs the filter above (2026-06-24). Checked BEFORE the
// filter map: handles here route to /collections/<real>, the rest fall through to the filter.
// `aromas-dulces` is intentionally absent (no real collection) so it keeps the filter behavior.
// Keep in sync with snippets/spot-plp-filter-url.liquid.
const SPOT_PLP_HANDLE_COLLECTION = {
    'difusores-de-varillas': 'difusores-de-varillas',
    'difusor-de-varilla': 'difusor-de-varilla',
    'difusor-de-varillas-150ml': 'difusor-de-varilla',
    'difusor-de-varillas-175ml': 'difusor-de-varillas-175ml',
    'difusor-de-varillas-250ml': 'difusor-de-varillas-250ml',
    'refill-difusor-de-varillas': 'refill-difusor-de-varillas',
    'home-sprays': 'home-spray',
    'home-spray-500ml-copia': 'home-spray-350ml',
    'spray-home-lh-500-ml': 'home-spray-500ml',
    'refill-home-spray': 'refill-home-spray',
    'refill': 'refill',
    'home-diffuser': 'home-diffusers',
    'home-diffusers': 'home-diffusers',
    'home-diffuser-1': 'home-diffuser-1',
    'esencia-concentrada': 'esencia-concentrada',
    'esencias-concentradas': 'esencia-concentrada',
    'aromatizadores-para-auto': 'aromatizadores-para-auto',
    'aromatizador-de-auto-copia': 'aromatizadores-para-auto',
    'alcohol-spray-100ml': 'alcohol-spray-100ml',
    'alcohol-spray-100ml-copia': 'pet-fabric-spray',
    'todo-aromas-frutales': 'todo-aromas-frutales',
    'aromas-frutales': 'todo-aromas-frutales',
    'todo-aromas-citricos': 'todo-aromas-citricos',
    'aroma-citrico': 'todo-aromas-citricos',
    'aromas-citricos': 'todo-aromas-citricos',
    'aromas-maderosos': 'aromas-maderosos-1',
    'aromas-maderosos-1': 'aromas-maderosos-1',
    'florales-1': 'florales-1',
    'velas-2025': 'velas-2025',
    'vela-de-soya-235gr': 'velas-2025',
    'vela-de-soya-415g': 'vela-de-soya-415g',
    'todo-velas-de-soya': 'todo-velas-de-soya',
}

const SPOT_PLP_MANUAL_HANDLES = new Set([
    'regalables',
    'on-the-go',
    'cyber-days-junio-2026',
    'alcohol-spray',
    'pet-spray',
    'pet-fabric-spray',
    'velas-de-soya',
    'florales',
])

// (SPOT_PLP_AROMA_HANDLES removed 2026-06-25 — aroma menu items now route to their real
// collection page instead of the /collections/all?filter aroma view.)

// Orden por defecto pedido por Palo (2026-07-28): precio de mayor a menor en el
// primer ingreso. Si el usuario elige algo en "Ordenar por", su elección manda.
const SPOT_DEFAULT_SORT = 'price-descending'

const getSpotCollectionHandle = (href) => {
    if (!href) return ''
    try {
        const url = new URL(href, window.location.origin)
        const match = url.pathname.match(/\/collections\/([^/?#]+)/)
        return match ? decodeURIComponent(match[1]) : ''
    } catch {
        return ''
    }
}

const resolveSpotMenuHref = (href) => {
    if (!href || href.startsWith('#') || href.includes('/products/')) return href

    try {
        const url = new URL(href, window.location.origin)
        if (url.pathname.endsWith('/collections/all')) return `${url.pathname}${url.search}`

        const handle = getSpotCollectionHandle(href)
        if (!handle || handle === 'all') return href

        if (SPOT_PLP_MANUAL_HANDLES.has(handle)) {
            return `/collections/${handle}`
        }

        const mappedCollection = SPOT_PLP_HANDLE_COLLECTION[handle]
        if (mappedCollection) {
            return `/collections/${mappedCollection}`
        }

        const mappedQuery = SPOT_PLP_HANDLE_QUERY[handle]
        if (mappedQuery) {
            return `/collections/all?${mappedQuery}&view=${encodeURIComponent(handle)}`
        }

        // Individual aroma collections route to their real collection page (the Shopify menu
        // already points to the real handle, e.g. aroma-ipanema / sandalwood). The aroma
        // metafield-filter rewrite was removed 2026-06-25 (Palo: drop the redirect for aromas).
    } catch {
        return href
    }

    return href
}

const isSpotPlpHref = (href) => {
    if (!href || href.includes('/products/')) return false
    return resolveSpotMenuHref(href).includes('/collections/all')
}

const isSpotPlpPage = () => {
    return Boolean(document.querySelector('.collection'))
        && window.location.pathname.endsWith('/collections/all')
}

const prefetchSpotPlp = (href) => {
    const resolved = resolveSpotMenuHref(href)
    if (!isSpotPlpHref(resolved)) return

    const url = new URL(resolved, window.location.origin).href
    if (spotPlpPrefetchCache.has(url)) return

    const request = fetch(url, { credentials: 'same-origin' })
        .then((response) => {
            if (!response.ok) throw new Error(`prefetch failed: ${response.status}`)
            return response.text()
        })
        .catch(() => {
            spotPlpPrefetchCache.delete(url)
            return null
        })

    spotPlpPrefetchCache.set(url, request)
}

const SPOT_OFFCANVAS_TRANSITION_MS = 320

const waitForSpotOffcanvasHidden = (el, timeoutMs = SPOT_OFFCANVAS_TRANSITION_MS + 120) => {
    return new Promise((resolve) => {
        if (!el?.classList.contains('show')) {
            resolve()
            return
        }

        let done = false
        const finish = () => {
            if (done) return
            done = true
            resolve()
        }

        el.addEventListener('hidden.bs.offcanvas', finish, { once: true })
        setTimeout(finish, timeoutMs)
    })
}

const closeSpotOffcanvasAnimated = async (selector) => {
    const el = document.querySelector(selector)
    if (!el?.classList.contains('show')) return

    const instance = bootstrap.Offcanvas.getInstance(el) || bootstrap.Offcanvas.getOrCreateInstance(el)
    instance.hide()
    await waitForSpotOffcanvasHidden(el)
}

const removeSpotOrphanBackdrops = () => {
    if (document.querySelector('.offcanvas.show')) return

    document.querySelectorAll('.offcanvas-backdrop, .modal-backdrop').forEach((node) => node.remove())

    document.body.classList.remove('offcanvas-open', 'modal-open', 'overflow-hidden')
    document.body.style.removeProperty('overflow')
    document.body.style.removeProperty('padding-right')
}

const forceCleanupSpotPlpOverlays = () => {
    document.querySelectorAll('.offcanvas.show').forEach((el) => {
        const instance = bootstrap.Offcanvas.getInstance(el)
        if (instance) {
            instance.dispose()
        }
        el.classList.remove('show', 'showing', 'hiding')
        el.setAttribute('aria-hidden', 'true')
        el.removeAttribute('aria-modal')
        el.style.removeProperty('visibility')
    })

    removeSpotOrphanBackdrops()

    document.querySelectorAll('[data-sort-custom][data-open]').forEach((root) => {
        root.removeAttribute('data-open')
        root.querySelector('[data-sort-trigger]')?.setAttribute('aria-expanded', 'false')
    })

    document.querySelectorAll('.navbar .dropdown-menu.show').forEach((menu) => {
        const toggle = menu.closest('.dropdown')?.querySelector('[data-bs-toggle="dropdown"]')
        bootstrap.Dropdown.getInstance(toggle)?.hide()
    })
}

const cleanupSpotPlpOverlays = async ({ animated = false } = {}) => {
    if (animated) {
        await Promise.all([
            closeSpotOffcanvasAnimated('#offcanvas-filters'),
            closeSpotOffcanvasAnimated('#offcanvas-menu'),
            closeSpotOffcanvasAnimated('#offcanvas-cart'),
            closeSpotOffcanvasAnimated('#offcanvas-search'),
        ])
        removeSpotOrphanBackdrops()
        return
    }

    forceCleanupSpotPlpOverlays()
}

const dismissSpotPlpOverlays = () => cleanupSpotPlpOverlays({ animated: true })

const applySpotPlpDocument = (newDocument) => {
    if (document.querySelector('.offcanvas.show')) {
        forceCleanupSpotPlpOverlays()
    } else {
        removeSpotOrphanBackdrops()
    }

    const nextCollection = newDocument.querySelector('.collection')
    const nextHero = newDocument.querySelector('[id*="__collection-hero"]')
    const nextOffcanvas = newDocument.querySelector('#offcanvas-filters')

    replaceNodeIfPresent(document.querySelector('.collection'), nextCollection)
    replaceNodeIfPresent(document.querySelector('[id*="__collection-hero"]'), nextHero)
    replaceNodeIfPresent(document.querySelector('#offcanvas-filters'), nextOffcanvas)

    const freshOffcanvas = document.querySelector('#offcanvas-filters')
    if (freshOffcanvas?.dataset.productsCount) {
        freshOffcanvas.dataset.productsCount = String(
            newDocument.querySelector('#offcanvas-filters')?.dataset.productsCount
                || freshOffcanvas.dataset.productsCount
        )
    }

    bootstrap.Offcanvas.getInstance(freshOffcanvas)?.dispose()
    initOffcanvasFiltersDeferredApply()
    updateOffcanvasFiltersFooter()

    if (typeof window.applySpotPlpViewHero === 'function') {
        window.applySpotPlpViewHero()
    }

    document.querySelectorAll('.collection [data-bs-toggle="popover"]')
        .forEach((el) => bootstrap.Popover.getOrCreateInstance(el))

    const customEvent = new CustomEvent('updated.ecomify.collection')
    window.dispatchEvent(customEvent)
}

// Load collection elements dynamically (filters, menu nav, sort)
const loadCollection = async (targetUrl = window.location.href) => {
    const navToken = ++spotPlpNavToken
    const collectionRoot = document.querySelector('.collection')
    let transition

    try {
        if (collectionRoot) {
            collectionRoot.classList.add('is-nav-loading')
        }

        const url = new URL(targetUrl, window.location.origin).href
        let htmlPromise = spotPlpPrefetchCache.get(url)
        if (htmlPromise) {
            spotPlpPrefetchCache.delete(url)
        } else {
            htmlPromise = fetch(url, { credentials: 'same-origin' }).then((response) => {
                if (!response.ok) throw new Error(`loadCollection failed: ${response.status}`)
                return response.text()
            })
        }

        transition = window.spotPageTransition?.show(htmlPromise)
        const data = await htmlPromise
        await transition?.covered
        if (!data || navToken !== spotPlpNavToken) return

        const parser = new DOMParser()
        const newDocument = parser.parseFromString(data, 'text/html')
        applySpotPlpDocument(newDocument)
    } catch (err) {
        if (navToken !== spotPlpNavToken) return
        console.error('loadCollection failed', err)
        window.location.assign(targetUrl)
    } finally {
        if (navToken === spotPlpNavToken) {
            document.querySelector('.collection')?.classList.remove('is-nav-loading')
            window.spotPageTransition?.hide(transition)
        }
    }
}

const navigateSpotPlp = async (href, { replace = false } = {}) => {
    const url = new URL(href, window.location.origin)
    const nextHref = `${url.pathname}${url.search}`

    if (`${window.location.pathname}${window.location.search}` === nextHref) return

    if (replace) {
        window.history.replaceState({ spotPlp: true }, '', nextHref)
    } else {
        window.history.pushState({ spotPlp: true }, '', nextHref)
    }

    await loadCollection(nextHref)

    const hero = document.querySelector('[id*="__collection-hero"]')
    if (hero) {
        hero.scrollIntoView({ behavior: 'smooth', block: 'start' })
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
}

const patchSpotMenuLinks = () => {
    document.querySelectorAll('a[href*="/collections/"]').forEach((link) => {
        const current = link.getAttribute('href')
        if (!current || current.includes('/products/')) return
        const resolved = resolveSpotMenuHref(current)
        let href = resolved && resolved !== current ? resolved : current

        // Shopify no deja configurar el orden por defecto de /collections/all, así
        // que se inyecta en los links internos. Si el link ya trae sort_by, se respeta.
        // El includes() acota el parseo a los hrefs que importan: patchSpotMenuLinks()
        // corre en el top-level del módulo y un throw acá mata todo collection.js.
        if (href.includes('/collections/all')) {
            const url = new URL(href, window.location.origin)
            if (url.pathname === '/collections/all' && !url.searchParams.get('sort_by')) {
                url.searchParams.set('sort_by', SPOT_DEFAULT_SORT)
                href = url.pathname + url.search
            }
        }

        if (href !== current) {
            link.setAttribute('href', href)
        }
    })
}

patchSpotMenuLinks()
document.addEventListener('DOMContentLoaded', patchSpotMenuLinks)

const initSpotPlpMenuNavigation = () => {
    if (!isSpotPlpPage()) return

    document.addEventListener('click', async (event) => {
        if (event.defaultPrevented) return

        const link = event.target.closest('a[href]')
        if (!link) return
        if (link.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

        const rawHref = link.getAttribute('href')
        if (!rawHref || rawHref.includes('/products/')) return

        const href = resolveSpotMenuHref(rawHref)
        if (!isSpotPlpHref(href)) return

        event.preventDefault()
        await dismissSpotPlpOverlays()
        navigateSpotPlp(href)
    })

    document.addEventListener('mouseover', (event) => {
        const link = event.target.closest('a[href]')
        if (!link) return
        prefetchSpotPlp(link.getAttribute('href'))
    }, { passive: true })

    window.addEventListener('popstate', () => {
        if (!isSpotPlpPage()) return
        loadCollection(window.location.href)
    })
}

initSpotPlpMenuNavigation()

const getOffcanvasFiltersForm = () => document.querySelector('#offcanvas-filters .collection-filters-form')

const buildOffcanvasFiltersUrl = (form) => buildCollectionFiltersUrl(form)

const getCurrentPlpUrl = () => {
    const query = window.location.search.replace(/^\?/, '')
    return query ? `${window.location.pathname}?${query}` : window.location.pathname
}

const hasOffcanvasFiltersPendingChanges = () => {
    const form = getOffcanvasFiltersForm()
    if (!form) return false
    return buildOffcanvasFiltersUrl(form) !== getCurrentPlpUrl()
}

const countOffcanvasActiveFilters = (form) => {
    if (!form) return 0

    let count = form.querySelectorAll('input[type="checkbox"]:checked').length
    const slider = form.querySelector('.filter-price-group-slider')

    if (slider) {
        const minInput = form.querySelector('[name="filter.v.price.gte"]')
        const maxInput = form.querySelector('[name="filter.v.price.lte"]')
        const rangeMin = Number(slider.dataset.rangeMin ?? 0)
        const rangeMax = Number(slider.dataset.rangeMax ?? 0)
        const minValue = Number(minInput?.value ?? rangeMin)
        const maxValue = Number(maxInput?.value ?? rangeMax)

        if (minValue > rangeMin || maxValue < rangeMax) {
            count += 1
        }
    }

    return count
}

const updateOffcanvasClearAllButton = (clearBtn, activeCount, offcanvas) => {
    if (!clearBtn) return

    clearBtn.hidden = activeCount === 0
    const template = offcanvas?.dataset.labelClear || 'Limpiar todo ( __COUNT__ )'
    clearBtn.textContent = template.replace('__COUNT__', String(activeCount))
}

const resetOffcanvasFiltersForm = (form) => {
    if (!form) return

    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        input.checked = false
    })

    form.querySelectorAll('.filter-price-group input[type="number"]').forEach((input) => {
        if (input.name.includes('.gte')) {
            input.value = '0'
        } else if (input.name.includes('.lte')) {
            const slider = form.querySelector('.filter-price-group-slider')
            input.value = slider?.dataset.rangeMax || input.max || ''
        }
    })

    const slider = form.querySelector('.filter-price-group-slider')
    if (slider?.noUiSlider) {
        slider.noUiSlider.set([
            Number(slider.dataset.rangeMin ?? 0),
            Number(slider.dataset.rangeMax ?? 0),
        ])
    }
}

const updateOffcanvasFiltersFooter = () => {
    const offcanvas = document.querySelector('#offcanvas-filters')
    const label = document.querySelector('#offcanvas-filters-apply [data-offcanvas-apply-label]')
    const clearBtn = document.querySelector('#offcanvas-filters .btn-filters-clear-all')
    const form = getOffcanvasFiltersForm()

    if (!offcanvas || !label || !form) return

    const pending = hasOffcanvasFiltersPendingChanges()
    const activeCount = countOffcanvasActiveFilters(form)
    const productsCount = offcanvas.dataset.productsCount || '0'

    if (pending) {
        label.textContent = offcanvas.dataset.labelApply || 'Aplicar filtros'
    } else if (Number(productsCount) === 1) {
        label.textContent = (offcanvas.dataset.labelViewOne || 'Ver __COUNT__ producto').replace('__COUNT__', productsCount)
    } else {
        label.textContent = (offcanvas.dataset.labelViewOther || 'Ver __COUNT__ productos').replace('__COUNT__', productsCount)
    }

    if (clearBtn) {
        updateOffcanvasClearAllButton(clearBtn, activeCount, offcanvas)
    }
}

let offcanvasFiltersApplying = false

const applyOffcanvasFilters = async ({ closeAfter = true } = {}) => {
    const form = getOffcanvasFiltersForm()
    if (!form || offcanvasFiltersApplying) return

    const url = buildOffcanvasFiltersUrl(form)
    const currentUrl = getCurrentPlpUrl()
    const hasChanges = url !== currentUrl

    offcanvasFiltersApplying = true
    try {
        if (hasChanges) {
            window.history.replaceState({}, '', url)
            if (closeAfter) await closeSpotOffcanvasAnimated('#offcanvas-filters')
            await loadCollection()
            return
        }

        if (closeAfter) await closeSpotOffcanvasAnimated('#offcanvas-filters')
    } finally {
        offcanvasFiltersApplying = false
    }
}

window.onChangeMobileOffcanvasFilter = (input, event) => {
    updateOffcanvasFiltersFooter()
}

window.onApplyOffcanvasFilters = async (btn, event) => {
    event?.preventDefault()
    await applyOffcanvasFilters({ closeAfter: true })
}

window.onCloseOffcanvasFilters = async (btn, event) => {
    event?.preventDefault()
    await applyOffcanvasFilters({ closeAfter: true })
}

const initOffcanvasFiltersDeferredApply = () => {
    const offcanvas = document.querySelector('#offcanvas-filters')
    if (!offcanvas || offcanvas.dataset.spotDeferredApplyBound) return

    offcanvas.dataset.spotDeferredApplyBound = '1'

    offcanvas.addEventListener('hide.bs.offcanvas', (event) => {
        if (offcanvasFiltersApplying) return
        if (!hasOffcanvasFiltersPendingChanges()) return

        event.preventDefault()
        applyOffcanvasFilters({ closeAfter: true })
    })

    offcanvas.addEventListener('shown.bs.offcanvas', () => {
        updateOffcanvasFiltersFooter()
    })
}

initOffcanvasFiltersDeferredApply()
window.addEventListener('updated.ecomify.collection', () => {
    initOffcanvasFiltersDeferredApply()
    updateOffcanvasFiltersFooter()
})

// Handle collection filters change events
window.onChangeCollectionFilter = async (input, event) => {
    if (input.closest('#offcanvas-filters')) {
        window.onChangeMobileOffcanvasFilter(input, event)
        return
    }

    const form = input.closest('form')
    const url = buildCollectionFiltersUrl(form)
    window.history.replaceState({}, '', url)

    await loadCollection()
}

// Handle collection price filters change
const initCollectionFiltersPriceChange = () => {
    document.querySelectorAll('.filter-price-group input').forEach(input => {
        input.addEventListener('input', window.debounce(async (event) => {
            const form = input.closest('form')

            if (input.closest('#offcanvas-filters')) {
                updateOffcanvasFiltersFooter()
                return
            }

            const url = buildCollectionFiltersUrl(form)
            window.history.replaceState({}, '', url)

            await loadCollection()
        }, 750))
    })
}
initCollectionFiltersPriceChange()
window.addEventListener('updated.ecomify.collection', initCollectionFiltersPriceChange)

// 'View more' within collection filters
window.onClickFiltersViewMore = (btn, event) => {
    btn.closest('.collapse').querySelectorAll('.form-check').forEach((elem) => {
        elem.removeAttribute('hidden')
    })

    btn.remove()
}

// 'Clear all' within collection filters
window.onClickClearAllFilters = async (btn, event) => {
    event?.preventDefault()
    const form = btn.closest('form')

    if (btn.closest('#offcanvas-filters')) {
        resetOffcanvasFiltersForm(form)

        const params = new URLSearchParams()
        const sortBy = form.querySelector('[name="sort_by"]')?.value
        if (sortBy) params.set('sort_by', sortBy)
        const basePath = form.getAttribute('action') || window.location.pathname
        const url = `${basePath}?${params.toString()}`
        window.history.replaceState({}, '', url)

        updateOffcanvasFiltersFooter()
        await closeSpotOffcanvasAnimated('#offcanvas-filters')
        await loadCollection()
        return
    }

    const params = new URLSearchParams()
    params.set('sort_by', form.querySelector('[name="sort_by"]').value)
    const basePath = form.getAttribute('action') || window.location.pathname
    const url = `${basePath}?${params.toString()}`
    window.history.replaceState({}, '', url)

    await loadCollection()
}

// Price filter slider with noUiSlider
const initPriceFilterSlider = () => {
    document.querySelectorAll('.filter-price-group-slider').forEach(slider => {
        const minValueField = slider.closest('form').querySelector('[name="filter.v.price.gte"]')
        const maxValueField = slider.closest('form').querySelector('[name="filter.v.price.lte"]')

        if (slider && slider.noUiSlider) {
            slider.noUiSlider.destroy()
        }

        noUiSlider.create(slider, {
            start: [
                Number(slider.dataset.minValue),
                Number(slider.dataset.maxValue)
            ],
            connect: true,
            range: {
                min: Number(slider.dataset.rangeMin),
                max: Number(slider.dataset.rangeMax)
            },
            step: 1,
            format: {
                to: (v) => String(Math.round(v)),
                from: (v) => Number(v),
            }
        })

        slider.noUiSlider.on('update', function (values) {
            minValueField.value = values[0]
            maxValueField.value = values[1]
        })

        slider.noUiSlider.on('change', function () {
            const event = new Event('input')
            minValueField.dispatchEvent(event)
            maxValueField.dispatchEvent(event)
        })
    })
}
initPriceFilterSlider()
window.addEventListener('updated.ecomify.collection', initPriceFilterSlider)

// Sort-by select change event
window.onChangeCollectionSortBy = (value) => {
    const params = syncSpotPlpViewParam(new URLSearchParams(window.location.search))
    params.set('sort_by', value)
    const url = `${window.location.pathname}?${params.toString()}`
    window.history.replaceState({}, '', url)

    loadCollection()
}

// Inifinite Pagination - on click "Load more" button
window.onClickCollectionLoadMore = async (btn, event) => {
    event.preventDefault()

    btn.style.width = `${btn.offsetWidth + 2}px`
    btn.style.height = `${btn.offsetHeight + 2}px`

    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm mx-auto" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    window.history.replaceState({}, '', btn.dataset.nextUrl)

    const respoonse = await fetch(window.location.href)
    const data = await respoonse.text()
    const parser = new DOMParser()
    const newDocument = parser.parseFromString(data, 'text/html')

    document.querySelector('.collection .product-list')
        .insertAdjacentHTML('beforeend', newDocument.querySelector('.collection .product-list').innerHTML)

    document.querySelector('#collection-pagination')
        .replaceWith(newDocument.querySelector('#collection-pagination'))

    document.querySelectorAll('.collection [data-bs-toggle="popover"]')
        .forEach((el) => bootstrap.Popover.getOrCreateInstance(el))

    const customEvent = new CustomEvent('updated.ecomify.collection')
    window.dispatchEvent(customEvent)
}

// Inifinite Pagination - on click "Load previous" button
window.onClickCollectionLoadPrevious = async (btn, event) => {
    event.preventDefault()

    btn.style.width = `${btn.offsetWidth + 2}px`
    btn.style.height = `${btn.offsetHeight + 2}px`

    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm mx-auto" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    window.history.replaceState({}, '', btn.dataset.previousUrl)

    const respoonse = await fetch(window.location.href)
    const data = await respoonse.text()
    const parser = new DOMParser()
    const newDocument = parser.parseFromString(data, 'text/html')

    document.querySelector('.collection .product-list')
        .insertAdjacentHTML('afterbegin', newDocument.querySelector('.collection .product-list').innerHTML)

    document.querySelector('#btn-load-previous')
        ?.replaceWith(newDocument.querySelector('#btn-load-previous'))

    document.querySelectorAll('.collection [data-bs-toggle="popover"]')
        .forEach((el) => bootstrap.Popover.getOrCreateInstance(el))

    const customEvent = new CustomEvent('updated.ecomify.collection')
    window.dispatchEvent(customEvent)
}

// Infinite Pagination - automatically load products on scroll
const initPaginationObserver = () => {
    const pagination = document.querySelector('#collection-pagination')

    if (!pagination) return

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const btn = pagination.querySelector('.btn-load-more')
                if (btn) btn.click()
            }
        })
    }, { threshold: 0, rootMargin: '0px 0px -100px 0px' })

    observer.observe(pagination)
}
initPaginationObserver()
window.addEventListener('updated.ecomify.collection', initPaginationObserver)

// Fixed utilities bar on Scroll. Desktop activa una "show on scroll" custom
// (sticky-top + inline top dinámico). Mobile NO usa este JS — usa CSS puro
// (position:sticky con top: var(--sticky-header-h) seteado en custom.js).
// Los listeners se registran siempre y el guard de viewport corre dentro de
// cada callback para tolerar resize sin recargar.
const isDesktopForUtilities = () => window.innerWidth >= 992
const fixedUtilitiesBarOnScroll = () => {
    const utilities = document.querySelector('#collection-utilities')

    if (!utilities) return

    // const top = utilities.getBoundingClientRect().top
    const top = 700

    document.addEventListener('scroll', window.throttle(() => {
        if (!isDesktopForUtilities()) return
        if (window.scrollY > top) {
            utilities.classList.add('sticky-top')
            utilities.style.top = 'var(--sticky-header-h, 0px)'
            setTimeout(() => {
                utilities.classList.add('show')
            }, 200)
        } else {
            utilities.classList.remove('show')
            setTimeout(() => {
                utilities.classList.remove('sticky-top')
                utilities.style.top = '0'
            }, 200)
        }
    }, 200))

    setInterval(() => {
        if (!isDesktopForUtilities()) return
        if (window.scrollY < 50) {
            utilities.classList.remove('sticky-top')
            utilities.style.top = '0'
        }
    }, 1000)
}
// Cuando el viewport baja a mobile, limpiamos inlines que dejó el desktop JS
// para que el CSS mobile (top: var(--sticky-header-h)) vuelva a aplicar.
window.addEventListener('resize', window.throttle(() => {
    const utilities = document.querySelector('#collection-utilities')
    if (!utilities) return
    if (!isDesktopForUtilities()) {
        utilities.style.removeProperty('top')
        utilities.classList.remove('sticky-top', 'show')
    }
}, 200))
fixedUtilitiesBarOnScroll()
window.addEventListener('updated.ecomify.collection', () => setTimeout(() => {
    fixedUtilitiesBarOnScroll()
}, 1000))

// 'Scroll top' button visibility
const handleScrollTopButton = () => {
    const btn = document.querySelector('#btn-collection-scroll-top')
    const productList = document.querySelector('.collection .product-list')

    if (!btn || !productList) return

    const top = productList.getBoundingClientRect().top

    document.addEventListener('scroll', window.throttle(() => {
        if (window.scrollY > top) {
            btn.classList.add('btn-show')
        } else {
            btn.classList.remove('btn-show')
        }
    }, 200))
}
handleScrollTopButton()
window.addEventListener('updated.ecomify.collection', handleScrollTopButton)

// Color swatches in product list items
window.showAllSwatchesWithinProductItem = (btn, event) => {
    const swatchesList = btn.closest('.color-swatches')
    swatchesList.querySelectorAll('li').forEach(elem => {
        elem.removeAttribute('hidden')
    })
    btn.remove()
}
